module.exports = __webpack_public_path__ + "media/video7.fec2760a.mp4";